export default {
  primary: "#DE2C5F",
  secundary: "#F86E7B",
  rose: "#FF4A76",
  pink: "#E838BC",
  violet: "#E62EE8",
  purple: "#C633FF",
  background: "#201823",
  backgroundLight: '#4D3A54',
  white: "#FFFFFF",
  light: "rgb(242, 242, 242)",
  gray: "rgb(102, 102, 102)",
  facebook: "#3b5998"
};
